import Config from "../Config";
import axios from "axios";

export async function getAvatarUsers(type, value) {
  const apiPath = `public/avatar`;

  let body;
  switch (type) {
    case 'phone':
      body = { phone: value };
      break;
    case 'taxNumber':
      body = { taxNumber: value };
      break;
    default:
      body = {};
      break;
  }

  const request = {
    url: `https://${Config.DYNAMO_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: Config.DYNAMO_API_URL,
    path: apiPath,
    method: "POST",
    region: Config.AWS_REGION,
    service: "execute-api",
    body: JSON.stringify(body),
    data: body,
    headers: {
      "Content-Type": "application/json",
    },
  };
  const response = await axios(request);

  return response.data;
}
